export default function (userInputs, labels, store, adultPrice, childPrice) {
    const basket = []
    const isChild = userInputs.find((item) => item.name === 'isChild')
    const joinATeam = userInputs.find((item) => item.name === 'joinATeam')

    basket.push({
        label: labels.fighterJoinHoldTotalFighter,
        amount: '',
        price: '0 kr.',
        intPrice: 0
    })


    if (joinATeam && joinATeam.value) {
        if (isChild && isChild.value) {
            basket.push({
                label: labels.fighterJoinHoldTotalDeltagergebyr,
                amount: '',
                price: `${childPrice} kr.`,
                intPrice: childPrice
            })
        } else {
            basket.push({
                label: labels.fighterJoinHoldTotalDeltagergebyr,
                amount: '',
                price: `${adultPrice} kr.`,
                intPrice: adultPrice
            })
        }
    }

    store.dispatch('stafet/basket', { basket: basket })
}
